<template>
  <v-date-picker mode="time" v-model="value" :masks="masks" @input="$emit('update:time', value)">
    <template v-slot="{ inputValue, inputEvents }">
      <input
        :class="disableFormControl ? '' : 'bg-white border px-2 py-1 rounded form-control'"
        :value="inputValue"
        v-on="inputEvents"
        :placeholder="placeholder"
      />
    </template>
  </v-date-picker>
</template>

<script type="text/javascript">
export default {
  data () {
    return {
      // value: new Date(new Date().setHours(0,0,0,0)),
      value: '',
       masks: {
        input: 'hh:mm:ss',
      },
    }
  },
  props: ['time', 'placeholder', 'disableFormControl'],
  watch: {
    'time': 'getValue'
  },
  mounted() {
    this.getValue()
  },
  methods: {
    getValue() {
      this.value = this.time
    }
  }
}
</script>